import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getZendeskUrlAction } from '../../redux/support-widget';
import IconButton from '../IconButton/IconButton';
import ArrowLeft from '../Icons/ArrowLeft';
import Close from '../Icons/Close';
import Modal from '../Modal/Modal';
import Screens from './Screens';
import styles from './SupportWidget.css';

const SupportModal = ({ closeWidget, isVisible, getZendeskUrl, zendeskLoginUrl }) => {
  const [routeStack, setRouteStack] = useState(['home']);

  React.useEffect(() => {
    if (isVisible) {
      getZendeskUrl();
    }
  }, [isVisible]);

  const knowledgeBaseUrl =
    'https://peoplegrove.zendesk.com/hc/en-us/categories/23168458027035-PathwayU';

  const gotoScreen = useCallback(
    (screenId) => {
      setRouteStack((prev) => [...prev, screenId]);
    },
    [setRouteStack],
  );

  const goBack = useCallback(() => {
    setRouteStack((prev) => [...prev.slice(0, -1)]);
  }, [setRouteStack]);

  const handleClose = useCallback(() => {
    setRouteStack(['home']);
    closeWidget();
  }, [closeWidget, setRouteStack]);

  const openAccessAllTicketForm = useCallback(() => {
    if (zendeskLoginUrl) {
      const form = window.document.createElement('form');
      form.method = 'POST';
      form.target = '_blank';
      form.action = zendeskLoginUrl;
      window.document.body.appendChild(form);
      form.submit();
      window.document.body.removeChild(form);
    }
  }, [zendeskLoginUrl]);

  return (
    <Modal
      containerStyles={{
        width: '100%',
        maxWidth: '600px',
        background: '#fff',
        borderRadius: '4px',
      }}
      open={isVisible}
      ariaLabel="Support Widget Modal"
    >
      <div className={styles.header}>
        {routeStack.length > 1 ? (
          <IconButton
            onClick={goBack}
            icon={ArrowLeft}
            iconProps={{
              size: 14,
            }}
            aria-label="Back"
            role="button"
          />
        ) : (
          <div className={styles.spacer} />
        )}
        <h2 aria-label="Help" className={styles.heading}>Help</h2>
        <IconButton
          onClick={handleClose}
          icon={Close}
          iconProps={{
            size: 14,
          }}
          aria-label="Close"
          role="button"
        />
      </div>
      <div className={styles.content}>
        <Screens
          routeStack={routeStack}
          gotoScreen={gotoScreen}
          handleClose={handleClose}
        />
      </div>
      <div className={styles.footer}>
        <Link
          to={knowledgeBaseUrl || '#'}
          target="_blank"
          rel="noopener noreferrer"
        >
          Knowledge Base
        </Link>
        <Link
          to={'#'}
          onClick={() => openAccessAllTicketForm()}
          className={!zendeskLoginUrl ? styles.disabledLink : ''}
        >
          Access all your tickets here
        </Link>
      </div>
    </Modal>
  );
};

SupportModal.propTypes = {
  closeWidget: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  getZendeskUrl: PropTypes.func.isRequired,
  zendeskLoginUrl: PropTypes.string.isRequired,
};

export default connect(
  ({ supportWidget }) => ({
    zendeskLoginUrl: supportWidget.loginUrl,
  }),
  { getZendeskUrl: getZendeskUrlAction },
)(SupportModal);



// WEBPACK FOOTER //
// ./src/client/Components/SupportWidget/SupportModal.js